import { Routes } from '@angular/router';
import { SetupComponent } from './setup/setup.component';
import { SignupComponent } from './signup/signup.component';
import { ConfirmComponent } from './confirm/confrm.component';
import { SessionTokenGuard } from '../shared/router/guard/session';

export const AccountRoutes: Routes = [
  {
    path: 'setup',
    component: SetupComponent,
    canActivate: [ SessionTokenGuard ]
  },
  {
    path: 'signup',
    component: SignupComponent,
    canActivate: [ SessionTokenGuard ]
  },
  {
    path: 'confirm',
    component: ConfirmComponent
  }
];
